import { SvgIconProps } from './icon-props';

export default function Wine({ height = 20, width = 20, fill = '#030303' }: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M18.75 1.95L18.05 1.25L10 9.3L1.95 1.25L1.25 1.95L9.3 10L1.25 18.05L1.95 18.75L10 10.7L18.05 18.75L18.75 18.05L10.7009 10L18.75 1.95Z"
				fill={fill}
			/>
		</svg>
	);
}
